<template>
  <section class="mb-64">
    <h3 class="text-h4 mb-8">Hire with Premium</h3>
    <p class="text-body-2 mb-24">You're currently on a limited membership. Get Premium to directly connect with sitters.</p>

    <ul class="flex flex-col mb-24 md:flex-row md:justify-between">
      <li class="flex mb-8 md:flex-col md:text-center md:w-208">
        <MessageSentOutlineIcon class="mt-4 md:mb-4 md:mx-auto" color="#FF0064" />
        <div class="ml-14 md:ml-0">
          <p class="text-strong-body">Send secure messages</p>
          <p class="text-body-3">Get to know sitters <span class="inline md:block">via messaging</span></p>
        </div>
      </li>

      <li class="flex mb-8 md:flex-col md:text-center md:w-208">
        <TrustAndSafetyIcon class="mt-4 md:mb-4 md:mx-auto" color="#FF0064" />
        <div class="ml-14 md:ml-0">
          <p class="text-strong-body">Buy background checks</p>
          <p class="text-body-3">Run on caregivers as part of <span class="inline md:block">your vetting process</span></p>
        </div>
      </li>

      <li class="flex mb-8 md:flex-col md:text-center md:w-208">
        <AdventuresOutlineIcon class="mt-4 md:mb-4 md:mx-auto" color="#FF0064" />
        <div class="ml-14 md:ml-0">
          <p class="text-strong-body">Book Adventures</p>
          <p class="text-body-3">Find enrichment-focused <span class="inline md:block">care your kids will love</span></p>
        </div>
      </li>
    </ul>

    <div class="w-full md:mx-auto md:my-0 md:w-[218px]">
      <Button class="w-full" value="View Pricing Options" size="medium" variant="outlined" href="/upgrade/pricing" />
    </div>
  </section>
</template>

<script lang="ts">
import MessageSentOutlineIcon from '@/graphics/icons/MessageSentOutlineIcon.vue';
import AdventuresOutlineIcon from '@/graphics/icons/AdventuresOutlineIcon.vue';
import TrustAndSafetyIcon from '@/graphics/icons/TrustAndSafetyIcon.vue';
import Button from '@/components/button/Button.vue';

export default {
  name: 'PremiumUpgradeModule',
  components: {
    MessageSentOutlineIcon,
    AdventuresOutlineIcon,
    TrustAndSafetyIcon,
    Button,
  },
};
</script>
